export { default as SocialMediaWidget } from "./SocialMediaWidget";
